import * as React from 'react';
import { ThemeProvider } from 'telia-front-react';
import { useStores } from '../stores/RootStore';
import icons from '@teliaee/icons/sprite.svg';

interface Props {
  children?: React.ReactNode;
}

const ApplicationThemeProvider: React.FC<Props> = (props: Props): JSX.Element => {
  const { app } = useStores();
  return (
    <ThemeProvider brand={app} theme={app === 'super' ? 'dark' : 'light'} getIconPath={(name) => icons + name}>
      {props.children}
    </ThemeProvider>
  );
};
export default ApplicationThemeProvider;
